/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Back_To_ListInputs */



/**
* | output |
* | --- |
* | "Back to Help" |
*
* @param {Help_Back_To_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_back_to_list = /** @type {((inputs?: Help_Back_To_ListInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Back_To_ListInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour à l'aide")
	if (locale === "es") return /** @type {LocalizedString} */ ("Volver a la ayuda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Voltar à ajuda")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna alla guida")
	return /** @type {LocalizedString} */ ("Back to Help")
});